// Returns the side(s) to apply a border radius to
// for buttons that are displayed next to one another,
// based on whether the buttons are stacked or in a row.
// Used by ComboButton and Radiobutton.
export function getBorderRadius(index, numButtons, stacked) {
  const isLastButton = index === numButtons - 1;
  if (stacked) {
    if (index === 0) return 'top';
    return isLastButton ? 'bottom' : 'none';
  } else {
    if (index === 0) return 'left';
    return isLastButton ? 'right' : 'none';
  }
}
